module.exports = __webpack_public_path__ + "img/HLF.3c6f7a4e.jpg";